//src/components/home/serviceSectionContainer.jsx
import React from "react";
import Topic from "./topic";
import Services from "./services";

const ServiceSectionContainer = () => {
  return (
    <section className="revamp-services">
    <div className="container">
        <Topic head={"What We Do"} info={"We Provide The Best IT Solutions For Your Business"} />
        <Services />
    </div>
</section>
  );
};
export default ServiceSectionContainer;